import React, { useState } from 'react';

const AddPassword = ({ visible, onCreate, onCancel }) => {
  const [category, setCategory] = useState('');
  const [site, setSite] = useState('');
  const [username, setUsername] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleOk = async () => {
    setLoading(true);
    try {
      const values = { category, site, username, password: passwordValue };
      onCreate(values);
    } catch (errorInfo) {
      setMessage(`添加密码失败: ${errorInfo.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    visible ? (
      <div className="password-modal">
        <h3>添加新密码</h3>
        <div>
          <label>分类:</label>
          <select
            value={category}
            onChange={e => setCategory(e.target.value)}
          >
            <option value="AI">AI</option>
            <option value="网站">网站</option>
            <option value="账号">账号</option>
            <option value="其他">其他</option>
            <option value="导入">导入</option>
          </select>
        </div>
        <div>
          <label>网站:</label>
          <input
            type="text"
            value={site}
            onChange={e => setSite(e.target.value)}
          />
        </div>
        <div>
          <label>用户名:</label>
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
          />
        </div>
        <div>
          <label>密码:</label>
          <input
            type="text"
            value={passwordValue}
            onChange={e => setPasswordValue(e.target.value)}
          />
        </div>
        <div className="button-container">
          <button onClick={handleOk} disabled={loading}>
            {loading ? '创建中...' : '创建'}
          </button>
          <button onClick={onCancel}>取消</button>
        </div>
        {message && <div>{message}</div>}
      </div>
    ) : null
  );
};

export default AddPassword;
